import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

function showTraceIdToast(error: unknown): void {
  const traceId = (error as { traceId?: string })?.traceId;
  if (traceId != null && traceId !== "") {
    toast.error("A server error has occurred.", {
      description: `Reference: ${traceId.slice(0, 12)}…`,
      action: {
        label: "Copy",
        onClick: () => void navigator.clipboard.writeText(traceId),
      },
    });
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: error => showTraceIdToast(error),
  }),
  mutationCache: new MutationCache({
    onError: error => showTraceIdToast(error),
  }),
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      retry: (failureCount, error) => {
        // Don't retry on 401 errors - let the auth system handle token refresh
        if (error?.message?.includes("Request was not authorized"))
          return false;
        // Don't retry on 404 or other client errors
        if (error?.message?.includes("404"))
          return false;
        // Retry up to 2 times for other errors with exponential backoff
        return failureCount < 2;
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});
